import { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { MapPin, Phone, EnvelopeSimple } from "@phosphor-icons/react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/leads", { ...form, source: "contact" });
      toast.success("Thank you — we'll reach out within one business day.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) { toast.error(formatErr(err)); } finally { setLoading(false); }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 lg:grid-cols-2 gap-16">
      <div>
        <div className="overline text-gold-dark mb-6">Get in touch</div>
        <h1 className="font-display text-5xl md:text-6xl text-midnight tracking-tight">Say hello.<br /><span className="italic">We'll listen</span>.</h1>
        <p className="mt-6 text-midnight/70 max-w-lg leading-relaxed">Whether you're exploring a first conversation or a second opinion — we'd love to hear from you.</p>
        <div className="mt-12 space-y-6">
          <div className="flex gap-4 items-start"><MapPin size={22} className="text-gold-dark mt-0.5" /><div><div className="font-semibold text-midnight text-sm">Office</div><div className="text-sm text-midnight/70">New Delhi, India</div></div></div>
          <div className="flex gap-4 items-start"><Phone size={22} className="text-gold-dark mt-0.5" /><div><div className="font-semibold text-midnight text-sm">Phone</div><a href="tel:+917300838191" className="text-sm text-midnight/70 hover:text-gold-dark">+91 73008 38191</a></div></div>
          <div className="flex gap-4 items-start"><EnvelopeSimple size={22} className="text-gold-dark mt-0.5" /><div><div className="font-semibold text-midnight text-sm">Email</div><a href="mailto:manigrivfinancial@gmail.com" className="text-sm text-midnight/70 hover:text-gold-dark">manigrivfinancial@gmail.com</a></div></div>
        </div>
      </div>

      <form onSubmit={submit} data-testid="contact-form" className="bg-white rounded-2xl p-8 md:p-10 border border-black/5 shadow-[0_10px_40px_rgba(0,0,0,0.05)] space-y-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Name" testid="contact-name" required value={form.name} onChange={upd("name")} />
          <Field label="Email" testid="contact-email" type="email" required value={form.email} onChange={upd("email")} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Phone" testid="contact-phone" value={form.phone} onChange={upd("phone")} />
          <Field label="Subject" testid="contact-subject" value={form.subject} onChange={upd("subject")} />
        </div>
        <div>
          <label className="overline text-midnight/70">Message</label>
          <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={upd("message")} className="mt-2 w-full border-b-2 border-midnight/15 focus:border-gold outline-none pb-2 text-midnight resize-none bg-transparent" />
        </div>
        <button type="submit" disabled={loading} data-testid="contact-submit" className="btn-gold w-full md:w-auto">{loading ? "Sending…" : "Send message"}</button>
      </form>
    </div>
  );
}

function Field({ label, testid, ...props }) {
  return (
    <div>
      <label className="overline text-midnight/70">{label}</label>
      <input data-testid={testid} {...props} className="mt-2 w-full border-b-2 border-midnight/15 focus:border-gold outline-none pb-2 text-midnight bg-transparent" />
    </div>
  );
}
